// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".announcement-login[data-v-2f06baa2]{padding:6px 11.8px 7px 14px;border-radius:14px;border:1px solid #cfd8dc;background-image:linear-gradient(96deg,#fffff4,#fff7fd 31%,#f7ffff 67%,#fafffa);font-size:12px;font-weight:500;color:#2680eb;cursor:pointer}.announcement-login[data-v-2f06baa2]:hover{border:1px solid #bac8ce;text-decoration:none}", ""]);
// Exports
module.exports = exports;
